import React from 'react';
import './SignUpText.css';
import * as ServerComms from './Common/ServerComms';

import GoogleLogin from 'react-google-login';

const cellStyle={
    width:'50%',
    textAlign : 'center',
}


export default function App(props) {

  function responseGoogleYes(response){
    var tokenId = response.tokenId;
    var email = response.profileObj.email;
    var subdomainID = props.subdomainID;
    var setExtraScreenSet = props.setExtraScreenSet;

    var postFunction = function(responseIn){
        if (responseIn.t === "number"){
          var UserSubdomainID = +responseIn.v;
          props.updateUserInfo(UserSubdomainID, tokenId);
          setExtraScreenSet([]);
        }
    }

    var failFunction = function(){
      console.log("Fail");
    }

    var passObject = {
        fn:"signUpStuff",
        type:"google",
        email,
        tokenId,
        subdomainID,
      };
      
   ServerComms.fetchSomethingNoJson(passObject, postFunction, failFunction, [], 1);             

  }

  function responseGoogleFail(response){
    console.log(response);
  }


  return (
      <td style={cellStyle}>
        <GoogleLogin
            clientId="549662522339-6iq5nc8u80rd07ri0nmbtgg5lh58cneo.apps.googleusercontent.com"
            onSuccess={responseGoogleYes}
            onFailure={responseGoogleFail}
            cookiePolicy={'single_host_origin'}
          />
      </td>
  );  
}